export default __webpack_public_path__ + "static/media/maduro-1Closed.271a6477.jpg";